import React from 'react';

import * as styles from './FeaturedIcons.module.css';

const FeaturedIcons = ({ children }: { children: React.ReactNode }) => {
	return <ul className={styles.list}>{children}</ul>;
};

const FeaturedItem = ({
	children,
	icon,
}: {
	children: React.ReactNode;
	icon: React.ReactNode;
}) => {
	return (
		<li className={styles.item}>
			<div className={styles.circle}>{icon}</div>
			<div className={styles.content}>{children}</div>
		</li>
	);
};

FeaturedIcons.Item = FeaturedItem;
export default FeaturedIcons;
